<template>
  <b-overlay>
    <b-row>
      <b-col cols="12">
        <b-tabs lazy content-class="mt-3">
          <!-- ----------------Settings------------------- -->
          <b-tab title="Details" active>
            <b-tabs pills card vertical>
              <!-- Render Tabs, supply a unique `key` to each tab -->
              <b-tab
                @click="tabClick(data)"
                v-for="(data, index) in form1.formTranslations"
                :key="index"
                :title="data"
              >
                <b-form-group label="Label">
                  <b-form-input
                    v-model="fieldData.label[translationLanguage]"
                    type="text"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  v-if="fieldData.headerText"
                  label="Header Text (optional)"
                >
                  <b-form-input
                    v-model="fieldData.headerText[translationLanguage]"
                    type="text"
                  ></b-form-input>
                </b-form-group>

                <!-- image- -->
                <vue-dropzone
                  ref="myVueDropzone"
                  @vdropzone-success="vsuccess"
                  @vdropzone-error="verror"
                  id="dropzone"
                  :options="dropzoneOptions"
                  v-on:vdropzone-sending="sendingEvent"
                  :useCustomSlot="true"
                  class="m-5 p-3"
                  style="border: dashed 1px"
                  type="file"
                >
                  <div class="dropzone-custom-content">
                    <h3 class="dropzone-custom-title">
                      {{ $t("upload.dragDrop") }}
                    </h3>
                    <div class="subtitle">
                      {{ $t("upload.dragDropContnt") }}
                    </div>
                  </div>
                </vue-dropzone>
                <!-- for preview thumbnail -->
                <b-img-lazy
                  v-if="
                    fieldData.file &&
                    fieldData.file[translationLanguage] &&
                    fieldData.file[translationLanguage].globeURL
                  "
                  v-bind="mainProps"
                  :src="apiURL+fieldData.file[translationLanguage].globeURL"
                  alt="Image"
                >
                </b-img-lazy>
                <font-awesome-icon
                  v-if="
                    fieldData.file &&
                    fieldData.file[translationLanguage] &&
                    fieldData.file[translationLanguage].globeURL
                  "
                  size="2x"
                  icon="trash"
                  @click="fieldData.file[translationLanguage] = {}"
                />
              </b-tab>
            </b-tabs>
          </b-tab>
          <b-tab title="Image Settings">
            <b-form-group label="Height (px)">
              <b-form-input
                v-model="fieldData.height"
                type="number"
              ></b-form-input>
            </b-form-group>
            <b-form-group label="Width (px)">
              <b-form-input
                v-model="fieldData.width"
                type="number"
              ></b-form-input>
            </b-form-group>
          </b-tab>
        </b-tabs>
      </b-col>
      <!-- End of column -->
    </b-row>
  </b-overlay>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
import { EventBus } from "@/event-bus.js";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import VueDropzone from "./Dropzone/VueDropzone";
import { HTTP } from "../utils/HTTP";
import { Helper } from "../helpers";
// language js
import "codemirror/mode/javascript/javascript.js";
// theme css
import "codemirror/theme/base16-dark.css";
export default {
  name: "AdvanceSettingsImage",
  components: {
    VueDropzone,
  },
  data() {
    return {
      apiURL: process.env.VUE_APP_API_URL,
      translationLanguage: "english",
      isHidden: false,
      hasImage:
        this.fieldData.imageData && this.fieldData.imageData.url ? true : false,
      imgFile: null,
      imgUrl: null,
      condition: {},
      mainProps: {
        center: true,
        blank: true,
        blankColor: "#bbb",
        height: 100,
        width: 150,
        class: "m1",
      },
      showToolTip: false,
      label: undefined,
      showSettings: false,
      collapse: true,
      dropzoneOptions: {
        maxFiles: 1,
        url: process.env.VUE_APP_API_URL + "v1/uploads/file/ddq",
        // url: "https://demo-kevin.ethixcloud.com/api/v1/uploads/file/ddq",
        thumbnailWidth: 150,
        maxFilesize: 25,
        addRemoveLinks: true,
        // acceptedFiles: this.fieldData.configuration.selectedFormats.join(),
        // acceptedFiles: "image/jpeg,image/png,image/jpg,.jpeg,.jpg,.png",
        acceptedFiles: "image/*",

        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
      },
    };
  },
  created() {
    EventBus.$on("onSaveSettings", (value) => {});
  },

  mounted() {
    this.addExtras();
  },

  computed: {
    ...mapGetters(["form1", "selectedLanguage"]),
    ...mapState(["toggleAllCoppalse"]),
  },

  methods: {
    ...mapActions(["updateField"]),
    addExtras() {
      if (!this.fieldData.file) {
        let file = { english: {} };
        Object.assign(this.fieldData, { file });
      }
    },

    tabClick(key) {
      let lang = key.toLowerCase();
      this.translationLanguage = lang;
      if (this.fieldData.file && !this.fieldData.file[lang]) {
        this.fieldData.file = {
          ...this.fieldData.file,
          [lang]: {},
        };
      }
      // this.imgUrl = this.fieldData.file[this.translationLanguage];
      // console.log("this.fieldData--adter", this.fieldData);
    },
    addLanguageToField(language) {
      let tempKey = language.toLowerCase();
    },
    verror(file, message, xhr) {
      console.log("message", message);
      Helper.makeToast(
        this.$bvToast,
        "danger",
        message,
        this.$t("toast.title")
      );
      // this.$refs.myVueDropzone.removeFile(file);
    },

    vsuccess(file, response) {
      // console.log("file, response", file, response);
      if (file && response) {
        // this.fieldData.imageData = {
        //   filename: file.name,
        //   size: file.size,
        //   type: file.type,
        //   actions: "&nbsp;",
        //   dataURL: file.dataURL,
        //   globeURL: response.url,
        //   fileId: response.fileId || null,
        // };
        let uploadedFile = {
          filename: file.name,
          size: file.size,
          type: file.type,
          actions: "&nbsp;",
          dataURL: file.dataURL,
          globeURL: response.url,
          fileId: response.fileId || null,
        };
        this.fieldData.file[this.translationLanguage] = uploadedFile;
        this.fieldData.file[this.translationLanguage] = uploadedFile;
        // this.$refs.myVueDropzone.removeFile(file);
      }
    },

    sendingEvent(file, xhr, formData) {
      let meta_data = {
        language: this.selectedLanguage,
        elementTitle: this.fieldData.label,
        sectionTitle:
          this.$store.state.form1.formSection[this.sectionIndex].sectionTitle,
        sectionSubTitle:
          this.$store.state.form1.formSection[this.sectionIndex]
            .sectionSubTitle,
      };
      formData.append("formId", this.form1.formId);
      formData.append("fieldId", this.fieldData.id);
      formData.append("fieldIndex", this.fieldIndex);
      formData.append("sectionIndex", this.fieldIndex);
      formData.append("sectionId", this.fieldIndex);
      formData.append("taskId", localStorage.getItem("taskId"));
      formData.append("meta_data", JSON.stringify(meta_data));
    },
  },
  props: {
    fieldData: Object,
    sectionIndex: Number,
    fieldIndex: Number,
  },
};
</script>
<style>
.cursor {
  cursor: pointer;
}
</style>
